module.exports = __webpack_public_path__ + "static/img/confirm_reset.fdea0792.svg";